// import { getSummaryDate } from "./action";
import {GET_STATS,GET_SUMMARY_WEBSITE,GET_SUMMARY_DATE } from "./config";

const initialstate = {
    getStats:[],
    getSummaryWebsite:[],
    getSummaryDate:[]
}

const reducer = (state = initialstate,action) =>{
    switch(action.type){
        case GET_STATS:
            return {
                ...state,
                getStats:action.payload
            }
            case GET_SUMMARY_WEBSITE:
            return {
                ...state,
                getSummaryWebsite:action.payload
            }
            case GET_SUMMARY_DATE:
            return {
                ...state,
                getSummaryDate:action.payload
            }

        default:
            return state;
    }
}

export default reducer;